// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__2v4A2","text":"SelectPayment_text__1yXPb","title":"SelectPayment_title__1_ilN","btn":"SelectPayment_btn__2q274"};